module.exports = __webpack_public_path__ + "img/user.f9e951d1.svg";